import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Checkbox } from '~ui-kit/components/checkbox/checkbox';
import { theme } from '~ui-kit/theme';
import { FormControlLabel } from '../form-control-label';
import { BaseCheckboxProps } from './base-checkbox-props';

type LabelCheckboxProps = FieldRenderProps<string | number | boolean> & BaseCheckboxProps;

export function LabelCheckbox({
  input: { checked, onChange, value },
  label,
  fontSize,
  width = ['288px', '420px', '476px'],
  disabled,
}: LabelCheckboxProps) {
  return (
    <FormControlLabel
      control={
        <Checkbox checked={checked} onChange={onChange} disabled={disabled} value={value} checkedColor="white" />
      }
      width={width}
      height={theme.sizes.inputHeight}
      label={label}
      checked={checked}
      fontSize={fontSize}
    />
  );
}
